import { FC, useState } from "react";

import { Card, Layout } from "antd";

import { LoginForm } from "./loginFormComponent";
import ForgotPasswordForm from "./forgotPasswordFormComponent";

import "./index.css";

interface LoginProps {
  title: string;
}

export const LoginPage: FC<LoginProps> = () => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const s3Url = process.env.REACT_APP_S3_URL;


  return (
    <div className="login">
      <div className="login_first-collumn"  style={{ backgroundImage: `url(${s3Url}login_image.jpg)`,
}}>
        <div className="login_text-container">
          <div className="login_line"></div>
          <div className="login_first-collumn-text">
            <p className="login_text-title">
              ¡Hola! Te damos la bienvenida al
              <br />
              PORTAL DE PRODUCTORES
            </p>
            <p>Accedé a tu cuenta</p>
          </div>
        </div>
      </div>
      <Layout>
        <div className="login-container">
          <Card className="login_card">
            {!showForgotPassword ? (
                <LoginForm
                  onForgotPassword={() => setShowForgotPassword(true)}
                />
              ) : (
                <ForgotPasswordForm
                  onBackToLogin={() => setShowForgotPassword(false)}
                />
              )}
          </Card>
        </div>
      </Layout>
    </div>
  );
};
